import { BaseService } from "@/api/base-service";
import type { Exercise, ExercisesParams } from "./types";
import { buildQueryParams } from "@/utils/build-query-params";

export class ExercisesService extends BaseService {
  static get instance(): ExercisesService {
    return this.getInstance<ExercisesService>();
  }

  public async getExercises(params: ExercisesParams = {}) {
    const queryParams = buildQueryParams(params);
    const url = `/exercises${queryParams ? `?${queryParams}` : ""}`;
    return this.client.getWithHeaders<{ exercises: Exercise[] }>(url);
  }

  public async getExercise(id: string): Promise<Exercise> {
    const response = await this.client.get<{ exercise: Exercise }>(
      `/exercises/${id}`,
    );
    return response.exercise;
  }

  public async createExercise(data: FormData): Promise<Exercise> {
    const response = await this.client.post<{ exercise: Exercise }>(
      "/exercises",
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response.exercise;
  }

  public async updateExercise(id: string, data: FormData): Promise<Exercise> {
    const response = await this.client.patch<{ exercise: Exercise }>(
      `/exercises/${id}`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response.exercise;
  }
}
